export const editProfileShowBankAccountInfo: boolean = false;
